(ns hai.home.onboarding
  "Tips and tricks state: which setup steps the user has stamped done, and
   whether the card is collapsed to its header. Both persist per user in
   `:user-config/onboarding`, which rides along on `:auth/identity`.

   A stamp records only that the user is finished with a step — it never acts
   on their behalf. The home-page step carries a real switch for
   `:user-config.newtab/override?`, but its box is separate state, so someone
   who means to skip that step can stamp it without the new-tab setting
   changing under them."
  (:require
   [hai.onboarding :as onboarding]
   [hai.ui.rf-sugar :refer [defevent-fx defsub]]))

;; TODO(evgheni): Tips and tricks is a card the web app hardcodes onto Home
;; rather than a mini-app record, so it has nowhere of its own to keep a
;; collapsed flag and rides along in the onboarding progress map instead. Give
;; it a real mini-app entity in Datomic, plus the machinery to pick which
;; surfaces it runs on (web app, browser extension, …), and it collapses through
;; the same path as every other mini-app.
(def collapsed-key :onboarding/collapsed?)

;; ---------------------------------------------------------------------------
;; Reads
;; ---------------------------------------------------------------------------

(defsub ::progress
  [identity <- :auth/identity]
  (:user-config/onboarding identity))

(defsub ::done
  [progress <- ::progress]
  (reduce (fn [acc {:keys [key]}] (assoc acc key (boolean (get progress key))))
          {}
          onboarding/steps))

(defsub ::remaining
  [done <- ::done]
  (count (remove val done)))

(defsub ::collapsed?
  [progress <- ::progress]
  (boolean (get progress collapsed-key)))

;; The live setting behind the home-page step's switch — its own state, not the
;; step's stamp.
(defsub ::homepage-override?
  [identity <- :auth/identity]
  (boolean (:user-config.newtab/override? identity)))

;; ---------------------------------------------------------------------------
;; Writes
;; ---------------------------------------------------------------------------

;; Datomic omits the attr until the first stamp, so this is nil for a new user
;; — and `into` onto nil would build a list rather than a map.
(defn- progress-of
  [db]
  (or (get-in db [:auth/identity :user-config/onboarding]) {}))

(defn- stamp
  "Store `progress` — the whole map, not a delta — locally and on the server."
  [db progress]
  {:db (assoc-in db [:auth/identity :user-config/onboarding] progress)
   :resolve {:query `[(~'user/save-onboarding ~{:onboarding/progress progress})]}})

(defevent-fx ::toggle-step
  [{:keys [db]} step-key]
  (stamp db (update (progress-of db) step-key not)))

;; Stamps whatever is still open. Stamps act on nothing, so this changes no
;; setting either — and it leaves the card up.
(defevent-fx ::mark-all-done
  [{:keys [db]}]
  (stamp db (into (progress-of db) (map (juxt :key (constantly true))) onboarding/steps)))

(defevent-fx ::toggle-collapsed
  [{:keys [db]}]
  (stamp db (update (progress-of db) collapsed-key not)))
